import { render, staticRenderFns } from "./CompraDiretaLegadaDetalhesItens.vue?vue&type=template&id=51f5ed2a&scoped=true"
import script from "./CompraDiretaLegadaDetalhesItens.vue?vue&type=script&lang=js"
export * from "./CompraDiretaLegadaDetalhesItens.vue?vue&type=script&lang=js"
import style0 from "./CompraDiretaLegadaDetalhesItens.vue?vue&type=style&index=0&id=51f5ed2a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f5ed2a",
  null
  
)

export default component.exports